import type { BdHierarchicalValueNode } from '@bindoc-projects/chart-domain-lib';
import type {
  VirtualClinicAnalysisOperatingNumberItem,
  VirtualClinicAnalysisOperatingNumberLeafItem,
  VirtualClinicAnalysisOperatingNumberNodeItem,
} from '../resolving/operating-number-item';
import type { VirtualClinicAnalysisOperatingNumberFormatting } from './formatting/formatting';

export class AysVirtualClinicAnalysisOperatingNumberHelper {
  public static getValues(
    items: VirtualClinicAnalysisOperatingNumberItem[],
    formatting: VirtualClinicAnalysisOperatingNumberFormatting
  ): BdHierarchicalValueNode<number>[] | any {
    if (items.length > 0) {
      return items.map((it) => this._getValue(it, formatting));
    } else {
      return [];
    }
  }

  private static _getValue(
    node: VirtualClinicAnalysisOperatingNumberItem,
    formatting: VirtualClinicAnalysisOperatingNumberFormatting
  ): BdHierarchicalValueNode<number> {
    if (node.type === 'node') {
      let childrenValues: BdHierarchicalValueNode<any>[] = null;
      const hasNodeChild = (
        node as VirtualClinicAnalysisOperatingNumberNodeItem
      ).groupedValues.some((childNode) => this._hasNodeChild(childNode));

      // the last level should be in different formatting, so this stuff follows...
      if (hasNodeChild) {
        childrenValues = this.getValues(
          (node as VirtualClinicAnalysisOperatingNumberNodeItem).groupedValues,
          formatting
        );
      } else {
        childrenValues = (
          node as VirtualClinicAnalysisOperatingNumberNodeItem
        ).groupedValues.map((it) => this._getLeafValue(it, formatting));
      }

      return {
        value: formatting.value(
          (node as VirtualClinicAnalysisOperatingNumberNodeItem).aggregated
        ),
        children: childrenValues,
      };
    } else {
      return this._formattingLeaf(
        node as VirtualClinicAnalysisOperatingNumberLeafItem,
        formatting
      );
    }
  }

  private static _getLeafValue(
    node: VirtualClinicAnalysisOperatingNumberItem,
    formatting: VirtualClinicAnalysisOperatingNumberFormatting
  ): number {
    return this._formattingLeaf(
      node as VirtualClinicAnalysisOperatingNumberLeafItem,
      formatting
    );
  }

  private static _hasNodeChild(
    node: VirtualClinicAnalysisOperatingNumberItem
  ): boolean {
    if (node.type === 'leaf') {
      return false;
    } else {
      return true;
    }
  }

  private static _formattingLeaf(
    obj: VirtualClinicAnalysisOperatingNumberLeafItem,
    formatting: VirtualClinicAnalysisOperatingNumberFormatting
  ): number {
    if (formatting.value) {
      return formatting.value(obj.value);
    } else {
      return obj.value;
    }
  }
}
